"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreBuilder = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const react_redux_1 = require("react-redux");
const ChainEventItem_1 = require("../chain/ChainEventItem");
const ConnectButtonWrapper_1 = require("../connect/ConnectButtonWrapper");
const Web3UserAuthWrapper_1 = require("../connect/Web3UserAuthWrapper");
const Initializer_1 = require("../init/Initializer");
const ApprovableButtonWrapper_1 = require("../chain/ApprovableButtonWrapper");
const PersistentState_1 = require("../localStorage/PersistentState");
const TransactionList_1 = require("../chain/TransactionList");
class StoreBuilder {
    static build(userStateReducer, dataReducer, uiReducer, initModule, apiBaseUrl) {
        const store = toolkit_1.configureStore({
            // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
            // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(PersistentStateMiddleware),
            devTools: process.env.NODE_ENV !== "production",
            reducer: toolkit_1.combineReducers({
                connection: toolkit_1.combineReducers({
                    account: ConnectButtonWrapper_1.connectSlice.reducer,
                    walletAuth: Web3UserAuthWrapper_1.webAuthSlice.reducer,
                    userState: userStateReducer,
                }),
                data: toolkit_1.combineReducers({
                    init: Initializer_1.initSlice.reducer,
                    state: dataReducer,
                    watchEvents: ChainEventItem_1.chainEventsSlice.reducer,
                    approval: ApprovableButtonWrapper_1.approvableButtonSlice.reducer,
                    tokenList: Initializer_1.tokenListSlice.reducer,
                    transactions: TransactionList_1.transactionListSlice.reducer,
                }),
                ui: uiReducer,
            }),
        });
        PersistentState_1.PersistentState.instance().dispatchAll(store.dispatch);
        store.dispatch(Initializer_1.initThunk({ module: initModule, apiBaseUrl }));
        return store;
    }
}
exports.StoreBuilder = StoreBuilder;
StoreBuilder.Provider = react_redux_1.Provider; // To avoid double reference from other packages and duplicate redux issues
//# sourceMappingURL=StoreBuilder.js.map